<script>
import BaseFilter from './base';
import {isBlank} from "../../../../helpers";

export default {
  extends: BaseFilter,

  computed: {
    /**
     * @return {Object}
     */
    field() {
      return _.chain(this.fields)
          .toPairs()
          .first()
          .thru(([name, {alias}]) => ({name, alias: alias || name}))
          .value();
    },

    /**
     * @return {String}
     */
    value() {
      return _.get(this.filters, this.field.name, null);
    },
  },

  watch: {
    value: {
      handler(newVal, oldVal) {
        !_.isEqual(newVal, oldVal) && this.onValueChange(newVal, oldVal);
      },
      immediate: true,
    },
  },

  methods: {
    /**
     * @param {*} newVal
     * @param {*} oldVal
     */
    onValueChange(newVal, oldVal) {
      this.updateLabels(newVal);
    },

    /**
     * @param {*} value
     */
    onChange(value) {
      if (isBlank(value)) {
        this.emitFilterChange({});
      } else {
        this.emitFilterChange({[this.field.name]: value});
      }
    },

    /**
     * @param {*} value
     */
    updateLabels(value) {
      if (this.displayLabels !== true) {
        return;
      }

      this.emitLabelsChange(this.buildLabels(value));
    },

    /**
     * @param {Array|*} value
     * @return {Array}
     */
    buildLabels(value) {
      if (_.isArray(value)) {
        return this.getArrayableValueLabels(value);
      } else if (value) {
        return this.getSingleValueLabels(value);
      }

      return [];
    },

    /**
     * @return {Array}
     */
    getSingleValueLabels(value) {
      return [this.buildLabel(
          this.buildLabelContent(value),
          this.buildLabelKey(this.field.name),
          {}
      )];
    },

    /**
     * @param {Array} value
     * @return {Array}
     */
    getArrayableValueLabels(value) {
      return _.chain(value)
          .map((value, index, elements) => {
            return this.buildLabel(
                this.buildLabelContent(value, index),
                this.buildLabelKey(this.field.name, index),
                this.getArrayableLabelFilter(elements, index)
            );
          })
          .values()
          .value();
    },

    /**
     * @param {string} content
     * @param {string} key
     * @param {Object} filter
     */
    buildLabel(content, key, filter) {
      return {
        name: this.name,
        content,
        key,
        values: filter
      };
    },

    /**
     * @param {*} value
     * @param {Number} index
     * @return {string}
     */
    buildLabelContent(value, index = null) {
      return String(value);
    },

    /**
     * @param {*} args
     * @return {string}
     */
    buildLabelKey(...args) {
      return _.chain(args)
          .filter(item => !_.isNil(item))
          .join('_')
          .value();
    },

    /**
     * @param {Array} values
     * @param {Number} index
     * @return {Object}
     */
    getArrayableLabelFilter(values, index) {
      return _.chain(values)
          .filter((val, key) => key !== index)
          .values()
          .thru(values => {
            return _.size(values) > 0 ? {[this.field.name]: values} : {};
          })
          .value();
    },
  },
}
</script>
